Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "GroupRules2252560536",
  {"root":"GroupRules2252560536--root","header":"GroupRules2252560536--header","cardHeader":"GroupRules2252560536--cardHeader","rule":"GroupRules2252560536--rule","title":"GroupRules2252560536--title","description":"GroupRules2252560536--description"},
  "",
  12,
  "GroupRules2252560536"
);

